jQuery.fn.Popup = function() {
	return this.each( function() {
		const element = jQuery( this );

		if ( 'undefined' !== typeof setWithExpiry ) {
			const popup = getWithExpiry( 'popup' );
			if ( null == popup ) {
				jQuery( 'body' ).addClass( 'popup-add' );
				element.show();
			} else {
				jQuery( 'body' ).removeClass( 'popup-add' );
				element.hide();
			}
		} else {
			console.log(
				'Please add the local-data dependency for the code to work fully -> Popup lib'
			);
		}

		element.find( '.close-button' ).click( function() {
			jQuery( this ).parents().find( 'body' ).addClass( 'popup-remove' );
			jQuery( this ).parents().find( 'body' ).removeClass( 'popup-add' );
			if ( 'undefined' !== typeof setWithExpiry ) {
				setWithExpiry( 'popup', 'closed', 0, 86400 * 60 * 24 ); // 1 Day
			}
		} );
		function getWithExpiry( key ) {
			const itemStr = localStorage.getItem( key );
			if ( ! itemStr ) {
				return null;
			}
			const item = JSON.parse( itemStr );
			const now = new Date();
			if ( now.getTime() > item.expiry ) {
				localStorage.removeItem( key );
				return null;
			}
			return item;
		}
		function setWithExpiry( key, value, discount = 0, ttl ) {
			const now = new Date();
			const item = {
				value,
				discount,
				expiry: now.getTime() + ttl,
			};
			localStorage.setItem( key, JSON.stringify( item ) );
		}
	} );
};
